var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6.22c.332 0 .6.267.6.598v6.633l.994-.994a.601.601 0 0 1 .981.653.599.599 0 0 1-.132.195l-2.018 2.018a.6.6 0 0 1-.849 0l-2.019-2.018a.6.6 0 1 1 .85-.848l.993.994V6.818A.6.6 0 0 1 8 6.22ZM7.03.59a5.124 5.124 0 0 1 3.276.461 5.12 5.12 0 0 1 2.128 2.034 3.8 3.8 0 0 1 3.263 2.313c.202.474.304.976.304 1.492 0 2.202-1.181 3.52-3.416 3.813l-2.056.005a.6.6 0 0 1 0-1.2h1.979C14.07 9.299 14.8 8.49 14.8 6.89a2.606 2.606 0 0 0-2.711-2.611c-.25-.012-.463-.126-.565-.344A3.906 3.906 0 0 0 7.259 1.77a3.92 3.92 0 0 0-2.193 1.26 3.916 3.916 0 0 0-.958 2.34.595.595 0 0 1-.467.549.595.595 0 0 1-.256.001 1.837 1.837 0 0 0-.798.013A1.821 1.821 0 0 0 1.2 7.693c0 .627.146 1.089.434 1.373.308.303.81.43 1.53.44h2.293a.6.6 0 1 1 0 1.2H3.174c-1.04.039-1.836-.248-2.382-.786C.267 9.403 0 8.654 0 7.693a3.027 3.027 0 0 1 1.116-2.338 3.021 3.021 0 0 1 1.869-.672 5.128 5.128 0 0 1 1.178-2.444A5.136 5.136 0 0 1 7.03.592V.59Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.672fae0b1e1942580927d87510728e83.svg";
export { ForwardRef as ReactComponent };